import React from 'react';
import { FileText, Check, AlertTriangle, Phone, Mail } from 'lucide-react';
const TermsConditions = () => {
  return <div className="w-full" data-id="element-842">
      {/* Hero Section */}
      <section className="bg-[#0a2e4a] text-white py-16" data-id="element-843">
        <div className="container mx-auto px-4" data-id="element-844">
          <div className="max-w-3xl mx-auto text-center" data-id="element-845">
            <h1 className="text-4xl font-bold mb-6" data-id="element-846">Terms & Conditions</h1>
            <p className="text-xl" data-id="element-847">
              Please read our terms and conditions carefully
            </p>
          </div>
        </div>
      </section>
      {/* Main Content */}
      <section className="py-16" data-id="element-848">
        <div className="container mx-auto px-4" data-id="element-849">
          <div className="max-w-3xl mx-auto" data-id="element-850">
            <div className="bg-white p-8 rounded-lg shadow-md mb-8" data-id="element-851">
              <div className="flex items-center mb-6" data-id="element-852">
                <FileText className="text-[#0a2e4a] mr-4 flex-shrink-0" size={28} data-id="element-853" />
                <h2 className="text-2xl font-bold text-[#0a2e4a]" data-id="element-854">Overview</h2>
              </div>
              <p className="text-gray-600 mb-4" data-id="element-855">
                This website (peakwave.it.com) is operated by Peakwave.
                Throughout this site, the terms "we," "us," and "our" refer to
                Peakwave. Peakwave provides this website, including all content,
                tools, and services, subject to your acceptance of these terms,
                conditions, policies, and notices.
              </p>
              <p className="text-gray-600" data-id="element-856">
                These Terms govern your use of the Peakwave website and your
                purchase of service plans.
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-md mb-8" data-id="element-857">
              <h2 className="text-2xl font-bold text-[#0a2e4a] mb-6" data-id="element-858">
                Company Information
              </h2>
              <div className="space-y-4" data-id="element-859">
                <p className="text-gray-600" data-id="element-860">Peakwave</p>
                <p className="text-gray-600" data-id="element-861">
                  22 Leith Walk, Edinburgh EH6 5AA
                </p>
                <div className="flex items-center" data-id="element-862">
                  <Mail className="text-[#f05a28] mr-2 flex-shrink-0" size={16} data-id="element-863" />
                  <span className="text-gray-600" data-id="element-864">
                    Email:{' '}
                    <a href="mailto:sunitalimbu9596@gmail.com" className="text-[#0a2e4a] hover:underline" data-id="element-865">
                      sunitalimbu9596@gmail.com
                    </a>
                  </span>
                </div>
                <div className="flex items-center" data-id="element-866">
                  <Phone className="text-[#f05a28] mr-2 flex-shrink-0" size={16} data-id="element-867" />
                  <span className="text-gray-600" data-id="element-868">
                    Phone:{' '}
                    <a href="tel:08000554969" className="text-[#0a2e4a] hover:underline" data-id="element-869">
                      0800 055 4969
                    </a>
                  </span>
                </div>
              </div>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-md mb-8" data-id="element-870">
              <h2 className="text-2xl font-bold text-[#0a2e4a] mb-6" data-id="element-871">
                Service Overview
              </h2>
              <p className="text-gray-600" data-id="element-872">
                Peakwave offers appliance repair and maintenance cover plans.
                Each plan entitles customers to unlimited repairs on covered
                appliances during the subscription period. Full details of each
                plan, including pricing, duration, and inclusions, are clearly
                available on our product and checkout pages.
              </p>
            </div>
            <div className="space-y-8" data-id="element-873">
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-874">
                <h3 className="text-xl font-semibold text-[#0a2e4a] mb-4" data-id="element-875">
                  Pricing and Currency
                </h3>
                <p className="text-gray-600" data-id="element-876">
                  All prices are in GBP (£ - British Pounds Sterling) and all
                  charges are processed in GBP. Payments are securely accepted
                  via Visa, Mastercard, and other major debit and credit cards.
                </p>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-877">
                <h3 className="text-xl font-semibold text-[#0a2e4a] mb-4" data-id="element-878">
                  Order Confirmation
                </h3>
                <p className="text-gray-600" data-id="element-879">
                  After completing your purchase, you'll receive an email
                  confirmation. If you don't receive this within one hour,
                  please contact{' '}
                  <a href="mailto:sunitalimbu9596@gmail.com" className="text-[#0a2e4a] hover:underline" data-id="element-880">
                    sunitalimbu9596@gmail.com
                  </a>
                  .
                </p>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-881">
                <h3 className="text-xl font-semibold text-[#0a2e4a] mb-4" data-id="element-882">
                  Dispute Resolution
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-883">
                  If you have concerns about your service plan or charges,
                  please contact us directly:
                </p>
                <div className="space-y-2" data-id="element-884">
                  <div className="flex items-center" data-id="element-885">
                    <Mail className="text-[#f05a28] mr-2 flex-shrink-0" size={16} data-id="element-886" />
                    <span className="text-gray-600" data-id="element-887">
                      Email:{' '}
                      <a href="mailto:sunitalimbu9596@gmail.com" className="text-[#0a2e4a] hover:underline" data-id="element-888">
                        sunitalimbu9596@gmail.com
                      </a>
                    </span>
                  </div>
                  <div className="flex items-center" data-id="element-889">
                    <Phone className="text-[#f05a28] mr-2 flex-shrink-0" size={16} data-id="element-890" />
                    <span className="text-gray-600" data-id="element-891">
                      Phone:{' '}
                      <a href="tel:08000554969" className="text-[#0a2e4a] hover:underline" data-id="element-892">
                        0800 055 4969
                      </a>
                    </span>
                  </div>
                </div>
                <p className="text-gray-600 mt-4" data-id="element-893">
                  We aim to resolve disputes promptly and fairly, with a focus
                  on excellent customer service.
                </p>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-894">
                <h3 className="text-xl font-semibold text-[#0a2e4a] mb-4" data-id="element-895">
                  Modifications
                </h3>
                <p className="text-gray-600" data-id="element-896">
                  We may revise these Terms from time to time. Continued use of
                  our site or services after changes means you accept the
                  updated Terms.
                </p>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-897">
                <h3 className="text-xl font-semibold text-[#0a2e4a] mb-4" data-id="element-898">
                  Service Plans
                </h3>
                <p className="text-gray-600" data-id="element-899">
                  Our plans cover repair and maintenance for selected
                  appliances. Detailed plan information is available on each
                  product page.
                </p>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-900">
                <h3 className="text-xl font-semibold text-[#0a2e4a] mb-4" data-id="element-901">
                  Payments
                </h3>
                <p className="text-gray-600" data-id="element-902">
                  We accept secure card payments and Direct Debit. You must be
                  authorized to use your chosen payment method.
                </p>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-903">
                <h3 className="text-xl font-semibold text-[#0a2e4a] mb-4" data-id="element-904">
                  Cancellation & Refund
                </h3>
                <p className="text-gray-600" data-id="element-905">
                  You can cancel within 14 days of purchase for a full refund.
                  Partial refunds may be considered up to 28 days at our
                  discretion, depending on whether any services have been
                  provided. After 28 days, refunds will no longer be available.
                </p>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-906">
                <h3 className="text-xl font-semibold text-[#0a2e4a] mb-4" data-id="element-907">
                  Liability
                </h3>
                <p className="text-gray-600" data-id="element-908">
                  We are not responsible for losses or damages caused by misuse
                  of appliances or systems, or from circumstances beyond our
                  reasonable control.
                </p>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-909">
                <h3 className="text-xl font-semibold text-[#0a2e4a] mb-4" data-id="element-910">
                  Contact Us & Dispute Resolution
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-911">For any issues, contact:</p>
                <div className="space-y-2" data-id="element-912">
                  <div className="flex items-center" data-id="element-913">
                    <Mail className="text-[#f05a28] mr-2 flex-shrink-0" size={16} data-id="element-914" />
                    <span className="text-gray-600" data-id="element-915">
                      Email:{' '}
                      <a href="mailto:sunitalimbu9596@gmail.com" className="text-[#0a2e4a] hover:underline" data-id="element-916">
                        sunitalimbu9596@gmail.com
                      </a>
                    </span>
                  </div>
                  <div className="flex items-center" data-id="element-917">
                    <Phone className="text-[#f05a28] mr-2 flex-shrink-0" size={16} data-id="element-918" />
                    <span className="text-gray-600" data-id="element-919">
                      Phone:{' '}
                      <a href="tel:08000554969" className="text-[#0a2e4a] hover:underline" data-id="element-920">
                        0800 055 4969
                      </a>
                    </span>
                  </div>
                </div>
                <p className="text-gray-600 mt-4" data-id="element-921">
                  We will reply during business hours.
                </p>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-922">
                <h3 className="text-xl font-semibold text-[#0a2e4a] mb-4" data-id="element-923">
                  Prohibited Use & Plan Exclusions
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-924">
                  To maintain fair use and service quality, the following are
                  excluded from all plans:
                </p>
                <ul className="space-y-3" data-id="element-925">
                  <li className="flex items-start" data-id="element-926">
                    <Check className="text-[#f05a28] mr-2 mt-1 flex-shrink-0" size={16} data-id="element-927" />
                    <span className="text-gray-600" data-id="element-928">
                      Faults or damage existing before plan activation.
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-929">
                    <Check className="text-[#f05a28] mr-2 mt-1 flex-shrink-0" size={16} data-id="element-930" />
                    <span className="text-gray-600" data-id="element-931">
                      Damage caused by misuse, neglect, or tampering.
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-932">
                    <Check className="text-[#f05a28] mr-2 mt-1 flex-shrink-0" size={16} data-id="element-933" />
                    <span className="text-gray-600" data-id="element-934">
                      Repairs unrelated to normal appliance function (e.g.,
                      cosmetic damage).
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-935">
                    <Check className="text-[#f05a28] mr-2 mt-1 flex-shrink-0" size={16} data-id="element-936" />
                    <span className="text-gray-600" data-id="element-937">
                      Illegal or fraudulent use of our services or website.
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-938">
                    <Check className="text-[#f05a28] mr-2 mt-1 flex-shrink-0" size={16} data-id="element-939" />
                    <span className="text-gray-600" data-id="element-940">
                      Appliances not used according to manufacturer guidelines.
                    </span>
                  </li>
                </ul>
                <p className="text-gray-600 mt-4" data-id="element-941">
                  If any of these apply, your plan may be cancelled without
                  refund or support.
                </p>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-942">
                <h3 className="text-xl font-semibold text-[#0a2e4a] mb-4" data-id="element-943">
                  Dispute Resolution (Emphasis)
                </h3>
                <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6" data-id="element-944">
                  <div className="flex items-start" data-id="element-945">
                    <AlertTriangle className="text-yellow-500 mr-3 flex-shrink-0" size={20} data-id="element-946" />
                    <p className="text-gray-600" data-id="element-947">
                      If you have an issue with your service or purchase, please
                      contact us first before raising a chargeback with your
                      bank. We strive to resolve disputes quickly and fairly.
                      Please avoid raising chargebacks before speaking with
                      us—we want to help.
                    </p>
                  </div>
                </div>
                <div className="space-y-2" data-id="element-948">
                  <div className="flex items-center" data-id="element-949">
                    <Mail className="text-[#f05a28] mr-2 flex-shrink-0" size={16} data-id="element-950" />
                    <span className="text-gray-600" data-id="element-951">
                      Email:{' '}
                      <a href="mailto:sunitalimbu9596@gmail.com" className="text-[#0a2e4a] hover:underline" data-id="element-952">
                        sunitalimbu9596@gmail.com
                      </a>
                    </span>
                  </div>
                  <div className="flex items-center" data-id="element-953">
                    <Phone className="text-[#f05a28] mr-2 flex-shrink-0" size={16} data-id="element-954" />
                    <span className="text-gray-600" data-id="element-955">
                      Phone:{' '}
                      <a href="tel:08000554969" className="text-[#0a2e4a] hover:underline" data-id="element-956">
                        0800 055 4969
                      </a>
                    </span>
                  </div>
                </div>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-957">
                <h3 className="text-xl font-semibold text-[#0a2e4a] mb-4" data-id="element-958">
                  Refunds
                </h3>
                <p className="text-gray-600" data-id="element-959">
                  Refunds will be returned to your original payment method.
                  Allow 5–10 working days for processing depending on your
                  provider.
                </p>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-960">
                <h3 className="text-xl font-semibold text-[#0a2e4a] mb-4" data-id="element-961">
                  Terms Acceptance
                </h3>
                <p className="text-gray-600" data-id="element-962">
                  By using our site or purchasing services, you agree to these
                  Terms of Service ("Terms"). They apply to all users including
                  browsers, customers, vendors, and content contributors. If you
                  don't agree to these Terms, please do not use the website or
                  services.
                </p>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-963">
                <h3 className="text-xl font-semibold text-[#0a2e4a] mb-4" data-id="element-964">
                  New Features
                </h3>
                <p className="text-gray-600" data-id="element-965">
                  Any new tools or features added will also be subject to these
                  Terms.
                </p>
              </div>
            </div>
            <div className="mt-12 bg-[#e6f4fa] p-8 rounded-lg" data-id="element-966">
              <h2 className="text-2xl font-bold text-[#0a2e4a] mb-6" data-id="element-967">
                Questions About Our Terms?
              </h2>
              <p className="text-gray-600 mb-6" data-id="element-968">
                If you have any questions about our Terms & Conditions, please
                don't hesitate to contact our customer support team.
              </p>
              <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-969">
                <a href="tel:08000554969" className="bg-[#0a2e4a] text-white px-6 py-3 rounded-md font-semibold text-center hover:bg-[#164875] transition flex items-center justify-center" data-id="element-970">
                  <Phone size={18} className="mr-2" data-id="element-971" /> Call: 0800 055 4969
                </a>
                <a href="/contact" className="bg-[#f05a28] text-white px-6 py-3 rounded-md font-semibold text-center hover:bg-[#d94e20] transition flex items-center justify-center" data-id="element-972">
                  <Mail size={18} className="mr-2" data-id="element-973" /> Contact Us
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default TermsConditions;